module.exports = __webpack_public_path__ + "img/ActionButton.3ebd8851.svg";